import { FC, Fragment } from 'react';
import { useTranslation } from 'next-i18next';
import { Divider, Typography } from 'antd';

import { Container } from '@/shared/components/layout';
import {
  DocumentCategoryToText,
  PersonalIdentifierType,
} from '@/shared/lib/sj-orm/models/document/personal-identifier.document.dto';

const typeList: PersonalIdentifierType[] = [
  PersonalIdentifierType.PASSPORT,
  PersonalIdentifierType.NATIONAL_ID,
  PersonalIdentifierType.RESIDENCE_PERMIT,
  PersonalIdentifierType.SUBSTANCE,
  PersonalIdentifierType.TAX_ID,
  PersonalIdentifierType.BIRTH_CERTIFICATE,
  PersonalIdentifierType.DRIVER_LICENSE,
  PersonalIdentifierType.INTERNATIONAL_DRIVER_LICENSE,
  PersonalIdentifierType.EDUCATION,
  PersonalIdentifierType.MEDICAL_ID,
  PersonalIdentifierType.MILITARY_ID,
  PersonalIdentifierType.SOCIAL_SECURITY,
  PersonalIdentifierType.FREE_BLOCK,
];

type PidCategoryListProps = {
  onSelect: (category: PersonalIdentifierType) => void;
};
// TODO category > type
export const PidCategoryList: FC<PidCategoryListProps> = ({ onSelect }) => {
  const { t } = useTranslation(['documents']);

  return (
    <>
      {typeList.map((iType) => (
        <Fragment key={iType}>
          <Divider style={{ margin: 0 }} />
          <Container paddingX={24} paddingY={16} style={{ cursor: 'pointer' }}>
            <Typography.Title
              level={4}
              onClick={() => onSelect(iType)}
              // style={!form ? { opacity: 0.7 } : {}}
              // data-testid={documentCategory}
            >
              {t(DocumentCategoryToText[iType])}
            </Typography.Title>
          </Container>
        </Fragment>
      ))}
      {/* {Object.entries(DocumentsForms).map(
        ([category, form]) =>
          !!form &&
          isPersonalIdentifier(category) && (
            <>
              <Divider style={{ margin: 0 }} />
              <Container paddingX={24} paddingY={16} style={{ cursor: 'pointer' }}>
                <Typography.Title
                  level={4}
                  onClick={() => onSelect(category as DocumentCategory)}
                  style={!form ? { opacity: 0.7 } : {}}
                  key={category}
                >
                  {t(DocumentCategoryToText[category as DocumentCategory])}
                </Typography.Title>
              </Container>
            </>
          ),
      )} */}
    </>
  );
};
